import { useRouter } from 'next/router';
import { useCallback, useState } from 'react';

import { parseToBool } from 'lib/string';

import useIsomorphicLayoutEffect from './useIsomorphicLayoutEffect';

const useRouterHashTag = (hashTagKey, defaultValue = null) => {
  const router = useRouter();
  const [hashTagValue, setHashTagValue] = useState(defaultValue);

  useIsomorphicLayoutEffect(() => {
    const hashTag = router.asPath.split('#')[1];

    if (!hashTag) {
      setHashTagValue(defaultValue);
      return;
    }

    const [key, value] = hashTag.split(':');

    if (key !== hashTagKey) {
      setHashTagValue(defaultValue);
      return;
    }

    if (typeof defaultValue === 'boolean') {
      setHashTagValue(parseToBool(value));
      return;
    }

    setHashTagValue(value);
  }, [router.asPath, hashTagKey, defaultValue]);

  const setHashTag = useCallback(
    (valueToStore) => {
      const parsedValue = JSON.stringify(valueToStore);
      const { pathname } = window.location;

      router.push(`${pathname}#${hashTagKey}:${parsedValue}`);
    },
    [router, hashTagKey]
  );

  return { hashTagValue, setHashTag };
};

export default useRouterHashTag;
